<script setup lang="ts">
import { useI18n } from '@/plugins/i18n'
import { useSearchStore } from '../../store/index.ts'
import CollectionsSearchInputArea from './CollectionsSearchInputArea.ce.vue';
import CollectionsSearchFilters from './CollectionsSearchFilters.ce.vue';
const searchStore = useSearchStore()
const { getItem } = searchStore

//props
const props = defineProps({
    showFilters: { type: Boolean, default: true },
    forMobile: { type: Boolean, default: false }
})

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance
</script>

<template>
    <div class="search-bar--collections">
        <CollectionsSearchInputArea :forMobile="forMobile"></CollectionsSearchInputArea>
        <CollectionsSearchFilters v-show="showFilters && getItem('collections.displayMoreSearchBarFilters')"></CollectionsSearchFilters>
    </div>
</template>